module.exports = __webpack_public_path__ + "img/1728523852653-bolu.jpg.e32703f5.webp";